const rolesDescription = (role) => {
  let description = "";
  const roleNames = {
    ADMIN: "System Administrator",
    CLEARANCE_MANAGER: "Clearance Manager",
    CLEARANCE_COORDINATOR: "Clearance Coordinator",
    CLEARANCE_AGENT: "Clearance Agent",
    SYASAT: "Syasat Coordinator",
    FINANCIAL: "Financial Coordinator",
    FORM_4: "Form 4 Coordinator",
    PLANNER: "Planner",
    PLANNING_MANAGER: "Planning Manager",
    TRANSPORTATION_COORDINATOR: "Transportation Coordinator",
    QUALITY_MEMBER: "Quality Member",
    WAREHOUSE_MEMBER: "Warehouse Member",
  };

  switch (role) {
    case "ADMIN":
      description =
        "streamlining the clearance process. You manage and maintain all system content, including users, clearance agents, " +
        "categories, suppliers, materials, shipping lines, warehouses, storage locations, banks, and planners, " +
        "ensuring accurate and up-to-date information for a seamless clearance experience.";
      break;
    case "CLEARANCE_MANAGER":
      description =
        "overseeing the end-to-end clearance operations across all orders. This strategic role tracks order progress, " +
        "resolves bottlenecks, and ensures timely delivery by managing and aligning the efforts of coordinators, agents, " +
        "and supporting teams involved in the customs process.";
      break;
    case "CLEARANCE_COORDINATOR":
      description =
        "initiating and orchestrating purchase orders from creation to release. Acting as the central point of coordination, " +
        "this role ensures timely progress across all phases of the clearance process, aligning cross-functional efforts to " +
        "drive efficiency and compliance.";
      break;
    case "CLEARANCE_AGENT":
      description =
        "executing customs clearance procedures. This includes submitting documentation, engaging with customs officials, " +
        "and physically processing the release of goods from ports or customs zones, ensuring full compliance with legal and " +
        "procedural standards.";
      break;
    case "SYASAT":
      description =
        "managing the approval process for regulatory and governmental bodies, particularly health authorities. This role " +
        "ensures that all necessary licenses, certifications, and regulatory endorsements are obtained to support the timely " +
        "and lawful clearance of goods.";
      break;
    case "FINANCIAL":
      description =
        "managing payment processes and tracking the financial lifecycle of each order. This includes initiating payment requests, " +
        "coordinating with accounting teams, and ensuring the timely issuance of invoices and financial documentation related to " +
        "clearance.";
      break;
    case "FORM_4":
      description =
        "overseeing the treasury-related aspects of purchase orders, including the preparation and submission of Form 4 " +
        "documentation to the designated banking institutions. This role ensures that all financial and regulatory " +
        "documentation is properly handled to facilitate customs clearance.";
      break;
    case "PLANNER":
      description =
        "initiating purchase requests based on production or operational needs. This role ensures that orders are planned in " +
        "line with industrial demand forecasts and business objectives, forming the starting point of the clearance process.";
      break;
    case "PLANNING_MANAGER":
      description =
        "leading the planning function, providing oversight and performance tracking for planners. This role mentors planning " +
        "staff, ensures alignment with business goals, and reviews order pipelines to optimize planning accuracy and " +
        "responsiveness to production needs.";
      break;
    case "TRANSPORTATION_COORDINATOR":
      description =
        "leading the planning function, providing oversight and performance tracking for planners. This role mentors planning " +
        "staff, ensures alignment with business goals, and reviews order pipelines to optimize planning accuracy and " +
        "responsiveness to production needs.";
      break;
    case "TRANSPORTATION_COORDINATOR":
      description =
        "overseeing goods movement from customs release to warehouse delivery. You record loading times, truck numbers, " +
        "and warehouse entry and exit, and upload supporting documents such as Customs Release and Delivery Notes. " +
        "Your updates ensure accurate tracking and full transparency throughout the transportation process.";
      break;
    case "QUALITY_MEMBER":
      description =
        "accessing shipment data to enhance visibility and traceability. You can review order details, quantities, and related documents " +
        "to monitor progress and ensure proper alignment between customs release and warehouse receipt, without modifying system records.";
      break;
    case "WAREHOUSE_MEMBER":
      description =
        "using system access for real-time visibility of shipments. You can track order details, quantities, and documents to confirm accurate " +
        "receipt and consistency with the customs release, supporting smooth warehouse operations without altering records.";
      break;
    default:
      return "";
  }
  return (
    `As the role of ${
      roleNames[role] || role
    } of the C-Gate System, you play a key role in ` + description
  );
};
export { rolesDescription };
